import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiResultModel, getContentFromApi } from "@tecumseh/Services/ContentSearchService";
import { CustomApiHandler } from "@tecumseh/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface Parameter {
    query?: string;
    onError?: (errorMessage: string) => void;
}

type HandlerType = CustomApiHandler<Parameter, ApiResultModel>;

export const StartLoading: HandlerType = props => {
    props.dispatch({
        type: "Custom/SearchResults/StartFetchingContents",
    });
};

export const GetContents: HandlerType = async props => {
    if (props.parameter.query) {
        try {
            const result = await getContentFromApi({ query: props.parameter.query });
            props.dispatch({
                type: "Custom/SearchResults/SetContents",
                contents: result.content,
            });
        } catch (error) {
            if (isApiError(error) && error.status === 400) {
                props.apiResult.errorMessage = error.errorJson.message;
                return;
            }
            throw error;
        }
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.apiResult?.errorMessage) {
        props.parameter.onError?.(props.apiResult.errorMessage);
    }
};

export const UpdateContentsQuery: HandlerType = props => {
    if (props.parameter.query) {
        props.dispatch({
            type: "Custom/SearchResults/UpdateContentsQuery",
            query: props.parameter.query,
        });
    }
};

export const chain = [UpdateContentsQuery, StartLoading, GetContents, ExecuteOnErrorCallback];

const searchContents = createHandlerChainRunner(chain, "searchContents");
export default searchContents;
